/**
 * CallTracker module for managing call tracking phone numbers based on source data.
 * Looks for a phone number called a "swap" number on the page and then dynamically replaces it with the call tracking number.
 * The appropriate call tracking number is determined based on the source data provided by the SourceTracker library.
 *
 * Requires SourceTracker library to be loaded on the page.
 * - Should wait for 'trmk:source-tracker-initialized' event before initializing.
 *
 * example usage:
 * jQuery(document).on('trmk:source-tracker-initialized', () => {
		TrimarkCallTracker.init({
			swap: '',
			default: '',
			triggers: {
				utm_source: {
					google: '555-1234',
					bing: '555-5678',
				},
				src: {
					google: '555-1234',
					bing: '555-5678',
				},
		});
		TrimarkCallTracker.updatePhones();
	});
 *
 * @returns {object} CallTracker
 */
const CallTracker = () => {
	const module = {
		/**
		 * Settings for the CallTracker library.
		 */
		settings: {},
		/**
		 * Initializes the CallTracker library.
		 *
		 * @param {object} settings
		 * @returns void
		 */
		init: function(settings) {
			if (typeof TrimarkSourceTracker === 'undefined') {
				console.warn('TrimarkSourceTracker is not initialized. CallTracker cannot function without it.');
				return;
			}

			this.settings = settings;
			this.updatePhones();
		},
		/**
		 * Gets the call tracking phone number based on the source data.
		 *
		 * @returns {string} The phone number to be used for call tracking.
		 */
		getCallTrackingPhone: function() {
			const sourceCookie = TrimarkSourceTracker.getSourceData();
			const {triggers} = this.settings;
			let targetPhone = '';

			// Loop through triggers
			// - 1st trigger that matches the source cookie will be used
			for (const trigger of Object.keys(triggers)) {
				if (sourceCookie.hasOwnProperty(trigger)) {
					Object.keys(triggers[trigger]).forEach(key => {
						if (key === sourceCookie[trigger]) {
							targetPhone = triggers[trigger][key].phone;
						}
					});
					break;
				}
			};

			return targetPhone;
		},
		/**
		 * Updates phone numbers in anchor tags that contain the specified swap number.
		 * @returns void
		 */
		updatePhones: function() {
			let phone = this.getCallTrackingPhone();

			// If user is a paid user, use the default phone number if no tracking number is found
			if (Cookies.get('trmk_is_paid') && phone === '') {
				phone = this.settings.default;
			}

			// If no phone number is found, do not update anything
			if (phone === '') {
				return;
			}

			$(`a:contains(${this.settings.swap})`).each((i, el) => {
				const $html = $(el).html();
				const newHtml = $html.replace(this.settings.swap, phone);

				// Update the href attribute to use the call tracking number
				$(el).attr('href', `tel:${phone.replace(/\D/g, '')}`);
				// Update the visible text to use the call tracking number
				$(el).html(newHtml);
			});
		},
	}

	return module;
}

/**
 * Jquery document ready.
 * Initialize CallTracker library globally so it can abe initalized from anywhere.
 */
window.TrimarkCallTracker = new CallTracker();
